import { API } from '@Providers';

interface ApplyCustomItemDiscountPayload {
  item_id: string;
  target_item: string;
  amount: number;
  discount_type?: 'percent' | 'fixed';
  discount?: number;
}

export default async function applyCustomItemDiscount(payload: ApplyCustomItemDiscountPayload) {
  const endpoint = '/api/shelter/cart/apply-custom-item-discount/';

  return API({ endpoint, method: 'put', payload });
}
